<template>
  <div>
    <div id="lineApex1"></div>
  </div>
</template>
<script>
export default {
  name: "LineApex",
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },
  methods:{
    initChart(){
      var options = {
          series: [{
            name: "ROI TREND",
            data: [81, 79, 87, 92, 83, 85, 91, 88, 89]
        }],
          chart: {
          height: 350,
          type: 'line',
          zoom: {
            enabled: false
          },
          toolbar: {
            show: false
          },
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'smooth'
        },
        title: {
          text: '',
          align: 'left'
        },
        grid: {
          row: {
            colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
            opacity: 0.5
          },
        },
        xaxis: {
          categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep'],
        }
        };

        var chart = new ApexCharts(document.querySelector("#lineApex1"), options);
        chart.render();
    }
  }
};
</script>
